import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #20: You can’t extend an object",
  "description": "",
  "published": "2016-08-21T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-20-you-cant-extend-an-object/swizec/6948"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`Today we battled with a fearsome error, an error of odd implications and no clear solutions. `}<inlineCode parentName="p">{`Uncaught TypeError: Super expression must either be null or function`}</inlineCode></p>
    <p>{`What does that even mean!? ?`}</p>
    <p>{`Well, it means that when you `}<inlineCode parentName="p">{`import TransitionableComponent from 'react-transitionable-component'`}</inlineCode>{`, you get an object instead of a function. We confirmed the problem with some console.log calls. After importing `}<inlineCode parentName="p">{`TransitionableComponent`}</inlineCode>{` is an object.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/08/Screen-Shot-2016-08-21-at-17.32.42.png",
        "alt": "It's an object!"
      }}></img></p>
    <p>{`It looks just like a React component is supposed to. There’s a constructor method, a bunch of default object methods, and – I assume – all the `}<inlineCode parentName="p">{`Component`}</inlineCode>{` methods as well. That’s great when you want to use a component in your `}<inlineCode parentName="p">{`render()`}</inlineCode>{` function. Not so great when you want to use it as a parent class.`}</p>
    <p>{`When you do something like `}<inlineCode parentName="p">{`class Arc extends TransitionableComponent`}</inlineCode>{`, it fails. You can extend a `}<inlineCode parentName="p">{`null`}</inlineCode>{` or a `}<inlineCode parentName="p">{`function`}</inlineCode>{`, but not an object.`}</p>
    <p>{`You can inherit from a class, but not from an instance of a class. I’m sure it’s like that in every language, but the reason it’s like that in JavaScript is that `}<inlineCode parentName="p">{`class TransitionableComponent extends Component`}</inlineCode>{` transpiles into:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var TransitionableComponent = (function (_Component) {
  _inherits(TransitionableComponent, _Component);

  function TransitionableComponent(props) {
    _classCallCheck(this, TransitionableComponent);

    // I think this is super(props)
    var _this = _possibleConstructorReturn(
      this,
      Object.getPrototypeOf(TransitionableComponent).call(this, props)
    );

    // this is where your constructor body goes
    return _this;
  }

  _createClass(TransitionableComponent, [
    {
      // this is where your class body goes
    },
  ]);

  return TransitionableComponent;
})(_react.Component);
`}</code></pre>
    <p>{`That `}<inlineCode parentName="p">{`_inherits`}</inlineCode>{` call is the crucial piece. It does a bunch of `}<inlineCode parentName="p">{`.prototype`}</inlineCode>{` magic to extend the definition of a given class with the definition of a child class. Instances don’t have prototypes, functions do.`}</p>
    <p>{`Functions have a `}<inlineCode parentName="p">{`prototype`}</inlineCode>{` property because of legacy reasons, I’m sure. That’s how JavaScript has always understood the concept of classes – generator/constructor functions double as classes.`}</p>
    <p>{`At this point `}<inlineCode parentName="p">{`TransitionableComponent`}</inlineCode>{` is a function - just like we’d expect. With some `}<inlineCode parentName="p">{`console.log`}</inlineCode>{`-ing we confirmed that it remains a function right until the point we import it in our sample project.`}</p>
    <p>{`Hmmm ?`}</p>
    <p>{`I don’t know why it becomes an object. Our guessing and prodding didn’t reveal much. This is what importing transpiles to:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var _TransitionableComponent = __webpack_require__(16);

var _TransitionableComponent2 = _interopRequireDefault(
  _TransitionableComponent
);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
`}</code></pre>
    <p>{`This code might return an object, if you’re importing something that isn’t an ES6 Module. But we know that’s not our problem because `}<inlineCode parentName="p">{`TransitionableComponent.default`}</inlineCode>{` is undefined.`}</p>
    <p>{`You’d think `}<inlineCode parentName="p">{`__webpack_require__`}</inlineCode>{` was instantiating our component and returning an object instead of a function, but it works correctly when you import React’s default `}<inlineCode parentName="p">{`Component`}</inlineCode>{`. Curiously, React’s compiled code looks like normal ES5 without even a hint of Webpack or Babel. Hmmm ?`}</p>
    <p>{`I am at a loss. I have no idea what’s going on or why. But until we figure this out, `}<inlineCode parentName="p">{`react-transitionable-component`}</inlineCode>{` will not be a usable library and my chance at open source glory lays trampled in the wastelands of `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-transitionable-component"
      }}>{`npmjs.com`}</a>{`. ?`}</p>
    <p>{`Ideas?`}</p>
    <p><em parentName="p">{`PS: the edited and improved versions of these videos are becoming a video course. Readers of the engineer package of `}<a parentName="em" {...{
          "href": "http://swizec.com/reactd3js/"
        }}>{`React+d3js ES6`}</a>{` get the video course for free when it’s ready.`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      